import React from "react";
import Button from 'devextreme-react/button';

function LVButtonAccion({ Ancho, onClick, Texto, visible = true, height, style, className, Disabled=false, Leyenda }) {

  return (
    <Button
      className={className}
      text={Texto}
      width={Ancho}
      height={height}
      type="default"
      stylingMode="outlined"
      onClick={onClick}
      disabled={Disabled}
      style={{ ...style, margin: '0 5px', borderRadius: '8px' }}
      visible={visible}
      hint={Leyenda} />
  );
}

export default LVButtonAccion

